import type { GooglePlugin } from '@shared/analytics/types/google'
import {
  onNoSearchResultEvent,
  removeNoSearchResultEvent,
} from '@shared/event/events/search'

const initSearchEvents = (Analytics: GooglePlugin) => {
  const noSearchResultToken = onNoSearchResultEvent(({ searchTerm }) => {
    if (searchTerm) {
      Analytics.event({
        event: 'no_search_result',
        search_term: searchTerm,
      })
    }
  })

  return () => {
    removeNoSearchResultEvent(noSearchResultToken)
  }
}

export default initSearchEvents
